import { useTranslations } from "next-intl";

import { Typography } from "@/components/ui/typography";
import { Link } from "@/i18n/routing";
import { ROUTES } from "@/routes";

interface ILegalProps {
    isLogging: boolean;
}

export const Legal = ({ isLogging }: ILegalProps) => {
    const t = useTranslations();

    return (
        <Typography variant="muted" className="text-center text-xs">
            {isLogging ? t("auth.legal.bySigningIn") : t("auth.legal.byCreatingAccount")}{" "}
            <Link href={ ROUTES.LEGAL.TERMS_OF_SERVICE } className="underline">
                {t("legal.termsOfService")}
            </Link>{" "}
            {t("auth.legal.and")}{" "}
            <Link href={ ROUTES.LEGAL.PRIVACY_POLICY } className="underline">
                {t("legal.privacyPolicy")}
            </Link>
        </Typography>
    );
};